import React, {
  useEffect,
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import Lottie from "lottie-react";

const CustomLottie = ({ 
  animationData,   //src del archivo que contiene la animación en JSON
  className,       // 
  segmentsToPlay=120,   // max KeyFrames (segments) que va a reproducir la animación
  ...props }, 
  ref
  ) => {
  // const{
  //     animationData,   //recibe el JSON de la animación

  // } = props;

  const lottieRef = useRef();

  const [isActive, setIsActive] = useState(false);
  const [playLottie, setPlayLottie] = useState(false);
  const [jsonData, setJsonData] = useState();

  useImperativeHandle(
    ref,
    () => {
      return {
        setPlay: () => setPlay(),
        stopAnimation: () => stopAnimation(),
      };
    },
    [props.value]
  );

  const setPlay = () => {
    if (!isActive) {
      setPlayLottie(true);
    } else {
      setPlayLottie(false);
    }
  };

  const stopAnimation = () => {
    setPlayLottie(false);
  };

  const LoadJsonFile = (file) => {
    return fetch(file)
      .then((response) => response.json())
      .then((jsonData) => {
        // jsonData is parsed json object received from url
        setJsonData(jsonData);
        // console.log(jsonData);
      })
      .catch((error) => {
        // handle your errors here
        console.error(error);
      });
  };

  useEffect(() => {
    if (playLottie) {
      lottieRef.current.playSegments([0, segmentsToPlay], true);
    }
    if (!playLottie) {
      lottieRef.current.goToAndStop(0, true);
    }
  }, [playLottie]);

  useEffect(() => {
    (async () => {
      LoadJsonFile(animationData);
    })();
  }, []);

  return (
    <div
      className={className}
      onMouseLeave={() => {
        stopAnimation();
      }}
      onMouseEnter={() => {
        setPlay();
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        ref={ref}
        animationData={jsonData}
        loop={false}
      ></Lottie>
    </div>
  );
};

export default forwardRef(CustomLottie);
